import Vue from 'vue'
import Index from './msgBox'

Vue.prototype.MsgBox = {
  open (options) {
    let DialogBoxConstructor = Vue.extend(Index)
    let instance = new DialogBoxConstructor({
      el: document.createElement('div')
    })

    for (var prop in options) {
      instance[prop] = options[prop]
    }
  }
}
